import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App.jsx";
import { store } from "./app/store.js";
import "./index.css";
import "ldrs/react/DotPulse.css";
import "react-datetime/css/react-datetime.css";
import { queryClientGlobal } from "./lib/tanstack-query/query.config.js";
import { CacheProvider } from "@emotion/react";
import { createEmotionCache } from "./emotionCache";
import { AgentModalProvider } from "./context/AgentModalContext.js";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
const cache = createEmotionCache();

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <CacheProvider value={cache}>
    <Provider store={store}>
      <AgentModalProvider>
        <QueryClientProvider client={queryClientGlobal}>
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
          <App />
        </QueryClientProvider>
      </AgentModalProvider>
    </Provider>
  </CacheProvider>,
);
